
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute(
	'href', 
	Liferay.ThemeDisplay.getPathContext() + '/o/frontend-js-components-web/code_mirror_keyboard_message/CodeMirrorKeyboardMessage.css'
);
document.querySelector('head').appendChild(link);
